import { useState, useRef, useEffect } from "react";
import { SearchIcon, BellIcon } from "@heroicons/react/solid";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const adminLinks = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/consultancies", label: "Consultancies" },
  { to: "/admin/students", label: "Students" },
  { to: "/admin/offers", label: "Offers" },
];

export default function AdminTopBar() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    const handler = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="sticky top-0 z-30 border-b border-white/10 bg-slate-950/80 px-4 py-3 backdrop-blur sm:px-6 sm:py-4">
      <div className="flex flex-wrap items-center gap-4 justify-between">
        <div>
          <p className="text-xs uppercase tracking-[4px] text-white/50 sm:text-sm sm:tracking-[6px]">AbroadJacks Admin</p>
          <h1 className="text-xl font-semibold text-white sm:text-2xl">Control Center</h1>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex items-center bg-white/10 border border-white/20 rounded-2xl px-3 py-2 gap-2">
            <SearchIcon className="h-4 w-4 text-white/60" />
            <input
              placeholder="Search anything..."
              className="bg-transparent outline-none text-sm text-white placeholder-white/60"
            />
          </div>
          <button className="p-3 rounded-full bg-white/10 border border-white/20 text-white relative">
            <BellIcon className="h-5 w-5" />
            <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-rose-400" />
          </button>
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setOpen((prev) => !prev)}
              className="flex items-center gap-3 rounded-2xl border border-white/20 bg-white/10 px-3 py-2 transition hover:-translate-y-0.5"
            >
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center text-white font-semibold">
                AD
              </div>
              <div className="hidden text-left sm:block">
                <p className="text-white font-semibold text-sm">Admin User</p>
                <p className="text-white/60 text-xs">Super Admin</p>
              </div>
            </button>
            {open && (
              <div className="absolute right-0 mt-3 w-52 rounded-2xl border border-white/10 bg-slate-900/90 backdrop-blur shadow-2xl">
                <button className="w-full text-left px-4 py-3 text-sm text-white hover:bg-white/10">
                  Profile
                </button>
                <button className="w-full text-left px-4 py-3 text-sm text-white hover:bg-white/10">
                  Settings
                </button>
                <button
                  onClick={() => {
                    logout();
                    navigate("/", { replace: true });
                  }}
                  className="w-full text-left px-4 py-3 text-sm text-rose-200 hover:bg-white/10"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <nav className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4 lg:hidden" aria-label="Admin mobile navigation">
        {adminLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `min-h-[44px] rounded-xl px-3 py-2 text-center text-sm font-semibold transition ${
                isActive ? "bg-white/15 text-white" : "bg-white/[0.06] text-white/75 hover:bg-white/10"
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
